import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy, computed } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ProfileSidebarComponent } from 'src/app/layout/profile-sidebar/profile-sidebar.component';
import { Services } from 'src/app/services/api.service';
import { OibCheckerService } from 'src/app/services/oib-checker-service';
import { ProfileService } from 'src/app/services/profile.service';
import { environment } from 'src/environments/environment';
import { ConnectMembershipComponent } from '../connect-membership/connect-membership.component';
import { MemberhsipCardComponent } from '../memberhsip-card/memberhsip-card.component';
import { TranslateModule } from '@ngx-translate/core';
import { MembershipCard } from './profile-membership.model';
import { NgxMaskDirective } from 'ngx-mask';
import { ErrorMessageService } from 'src/app/services/error-message.util';
import { oibValidator } from 'src/app/utils/validators';
import { NotificationComponent } from 'src/app/components/notification/notification.component';
import { getNotificationConfig } from 'src/app/utils/notification-config.util';
import { ModalService } from 'src/app/services/modal.service';
import { ModalNames } from 'src/app/common/modal.config';

@Component({
  selector: 'app-profile-membership',
  templateUrl:  `./${environment.pageFolder}/profile-membership.${environment.pageFolder}.component.html`,
  styleUrls:  [`./${environment.pageFolder}/profile-membership.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: [CommonModule, ProfileSidebarComponent, ConnectMembershipComponent, MemberhsipCardComponent, ReactiveFormsModule, TranslateModule, NgxMaskDirective, NotificationComponent]
})

export class ProfileMembershipComponent implements OnInit, OnDestroy {
  private subscription: Subscription = new Subscription();
  hasMembership!: boolean;
  hasOtherMembership: boolean = false;
  activePage: string = "";
  myMembership: boolean = true;
  membershipCard!: MembershipCard;
  membershipOthersCards: MembershipCard[] = [];
  isMembershipLoaded: boolean = false;
  loader = document.getElementById("loader-container");
  connectMembershipForm!: FormGroup;
  errorMessage: string = "";
  errorMessageMyMembership: string = "";
  infoMessage: string = "";
  successMessageOther: string = "";
  showConnectNewOtherMembershipContainer: boolean = false;
  oibInvalid = true;
  showConnectMembershipFlag: boolean = false;
  showProfileMemershipContainer: boolean = false;
  isClubFriend: boolean = false;
  routePath: string = "";
  showNotification: boolean = false;
  bodyText: string = '';
  page: string = environment.page;
  isMembershipModalOpen = computed(() => this.modalService.modalsState().get(ModalNames.Membership) ?? false);
  public readonly modalNamesEnum = ModalNames;
  
  constructor(
    private formBuilder: FormBuilder, 
    private service: Services, 
    private oibCheckerService: OibCheckerService, 
    private profileService: ProfileService,
    private route: ActivatedRoute,
    private readonly router: Router,
    private readonly errorMessageService: ErrorMessageService,
    private modalService: ModalService,
  ){}
  
  ngOnInit(): void {
    this.showNotificationModal();
    
    this.route.queryParams.subscribe(() => {
      this.setActivePage();
      this.buildConnectForm();
    });
   
    sessionStorage.removeItem("openPage");
  }

  private buildConnectForm() {
    const controls: Record<string, any> = {
      barcode:   ['', [ Validators.required ]],
      birthDate: ['', [ Validators.required ]]
    };

    if (!this.isClubFriend && environment.configId !== '4') {
      controls['oib'] = ['', [ Validators.required, oibValidator ]];
    }

    this.connectMembershipForm = this.formBuilder.group(controls);
  }

  setActivePage() {    
    const segments = this.route.snapshot.url;
    const routePath = segments.length > 0 ? segments[0].path : ''; 
    this.routePath = routePath;
    this.isClubFriend = false;

    if(routePath === "membership-profile-others") {
      this.myMembership = false;
      this.activePage = "membership-profile-others";
    } else if(routePath === "club-friends-profile") {
      this.myMembership = false;
      this.activePage = "club-friends-profile";
      this.isClubFriend = true;
    } else {
      this.activePage = "membership-profile";
      this.myMembership = true;
    }
    
    this.getMemberships(true);
  }
  
  getMemberships(initialState: boolean) {
    this.loader!.style.display = "flex";

    this.profileService.getMemberships(initialState).subscribe({
      next: data => {
        const response:any = data;
        this.hasMembership = response.data.own !== null;
        this.membershipCard = response.data.own;
        this.isMembershipLoaded = true;

        this.membershipOthersCards = [];
        this.hasOtherMembership = false;
        
        response.data.others.forEach((item: any) => {
          if(this.routePath === "club-friends-profile" && item.membershipType === "V4") {
            this.membershipOthersCards.push(item);
            this.hasOtherMembership = true;
          } else if(this.routePath === "membership-profile-others" && item.membershipType !== "V4") {
            this.membershipOthersCards.push(item);
            this.hasOtherMembership = true;
          }
        });

        this.showConnectMembershipFlag = false;
        this.showProfileMemershipContainer = true;
        this.loader!.style.display = "none";
      }, error: error => {
        this.loader!.style.display = "none";
      }
    })
  }

  showNewOtherMembershipContainer() {
    this.showConnectNewOtherMembershipContainer = true;
  }

  userFormValidation() {
    let inputs = document.querySelectorAll('input[data-name="connect-new-membership-input"]');    
    let error = false;
    
    inputs.forEach((item:any) => {     
      if(!item.value) {               
        item.nextElementSibling.style.width = "100%";
        item.nextElementSibling.style.backgroundColor = "#ed0000";
        error = true;
        this.errorMessageMyMembership = this.errorMessageService.getErrorMessage("allFieldsRequired");
      }
    })

    return error;
  }

  onSubmitConnectMembership(form: any) {
    let validationError = false;
    this.errorMessageMyMembership = "";
    
    this.connectMembershipForm.markAllAsTouched();

    if (this.connectMembershipForm.invalid) {
      const form = this.connectMembershipForm;

      if (form.hasError('required', 'barcode') || form.hasError('required', 'birthDate')) {
        this.errorMessageMyMembership = this.errorMessageService.getErrorMessage('allFieldsRequired');
      }
      return;
    }

    let isOibValid = true;
    let isDateBirthValid = true;

    if(this.isClubFriend) {
      isDateBirthValid = this.checkDateBirth();
    } else {
      isOibValid = this.checkOIB();
    }

    if(environment.configId === "1" && (!form.value.barcode || (!this.isClubFriend && !form.value.oib) || (this.isClubFriend && !form.value.birthDate))) {
      this.errorMessageMyMembership = this.errorMessageService.getErrorMessage("allFieldsRequired");
      return;
    }

    if(!isDateBirthValid) {
      let item:any = document.getElementById("birth-date");      
      item.nextElementSibling.style.width = "100%";
      item.nextElementSibling.style.setProperty("background-color", "#ed0000", "important");
      this.errorMessageMyMembership = this.errorMessageService.getErrorMessage("invalidBirthDate");
    }
   
    if(!isOibValid) {
      let item:any = document.getElementById("oib");      
      item.nextElementSibling.style.width = "100%";
      item.nextElementSibling.style.setProperty("background-color", "#ed0000", "important");
      this.errorMessageMyMembership = this.errorMessageService.getErrorMessage("invalidOIB");
      return;
    }

    let body;

    if((this.myMembership || !this.isClubFriend) && environment.configId !== "4") {
      body = { barcode: form.value.barcode.toString().trim(), oib: form.value.oib.trim() };
    } else {
      let birthDateElement:any = document.getElementById("birth-date");
      body = { barcode: form.value.barcode.toString().trim(), birthDate: birthDateElement.value.trim() };
    }
    if(this.myMembership && !validationError && isOibValid && isDateBirthValid) {
      this.loader!.style.display = "flex";
      this.subscription = this.service.onSubmitConnectMembershipService(body).subscribe({
        next: data => {
          const response:any = data.data;
          this.infoMessage = "";
          this.errorMessageMyMembership = "";
          this.checkResponseMessage(response.message);

          if(data.data.status) {
            this.getMemberships(false);
          } else {
            this.loader!.style.display = "none";
          }
        }
      })
    } else if(!this.myMembership && !validationError && isOibValid && isDateBirthValid) {
      this.loader!.style.display = "flex";
      this.subscription = this.service.onSubmitConnectOtherMembershipService(body, this.isClubFriend).subscribe({
        next: data => {
          const response:any = data.data;
          this.errorMessageMyMembership = "";
          this.infoMessage = "";
          this.checkResponseMessage(response.message);

          if(data.data.status) {
            this.getMemberships(false);
          } else {
            this.loader!.style.display = "none";
          }
        }
      })
    }
  } 

  checkResponseMessage(response: string): void {
    if(response === "ne_postoji_clanstvo") {
      this.errorMessageMyMembership = this.errorMessageService.getErrorMessage("invalidData");
    } else if(response === "ne_poklapa_se_ime_prezime") {
      this.errorMessageMyMembership = this.errorMessageService.getErrorMessage("nameAndSurnameMismatch");
    } else if(response === "nepostojeci_profil") {
      this.errorMessageMyMembership = this.errorMessageService.getErrorMessage("membershipNotFoundWithBarcode");
    } else if(response === "vec_dodano") {
      this.errorMessageMyMembership = this.errorMessageService.getErrorMessage("membershipAlreadyLinked");
    } else if(response === "OK") {
      this.infoMessage = this.errorMessageService.getSuccessMessage("membershipCardLinkedSuccess");
    } else if(response === "stariji_od_18") {
      this.errorMessageMyMembership = this.errorMessageService.getErrorMessage("membershipIsAdultConnectErrMsg");
    } else if(response === "isteklo_clanstvo") {
      this.errorMessageMyMembership = this.errorMessageService.getErrorMessage("membershipExpired");
    } else if(response === "neispravan_dat_rod_ili_maloljetan") {
      this.errorMessageMyMembership = this.errorMessageService.getErrorMessage("membershipInvalidBirthDateOrUnderAge");
    } else {
      this.errorMessageMyMembership = this.errorMessageService.getErrorMessage("error");
    }
  }

  removeErrorMessage() {
    this.errorMessageMyMembership = "";
  }

  goToBuyMembership() {
    sessionStorage.setItem("membershipHolder", "others");
    let profileTypeParams = this.isClubFriend ? "club-friend" : "full-fledged";

    this.router.navigate(
      [`/buy-membership`], 
      { queryParams: { type: profileTypeParams } }
    );
  }

  checkOIB() {
    let input:any = document.getElementById("oib")!;
    if(!input) {
      return true;
    }
    input.nextElementSibling.style.removeProperty("background-color", "#ed0000", "important");
    const oib = input.value.toString();
    this.errorMessageMyMembership = "";

    if (this.oibCheckerService.checkOIB(oib) === "valid") {
      this.errorMessageMyMembership = "";
      this.oibInvalid = false;
      return true;
    } else if(this.oibCheckerService.checkOIB(oib) === "invalid") {
      this.errorMessageMyMembership = "Neispravan OIB";
      this.oibInvalid = true;
      return false;
    } else {
      this.oibInvalid = true;
      return false;
    }
  }

  checkDateBirth() {
    let datebirthCheck = /^(0?[1-9]|[12][0-9]|3[01])[.]((0?[1-9]|1[012])[.](19|20)?[0-9]{2})*$/;
    let item:any = document.getElementById("birth-date");      
    return datebirthCheck.test(item.value);
  }

  showConnectMembership() {
    this.showConnectMembershipFlag = true;
  }

  limitInputLengthForNumberic(event: Event): void {
    const inputEl = event.target as HTMLInputElement;
    let inputValue = inputEl.value.replace(/\D/g, '');
    if (inputValue.length > 12) {
      inputValue= inputValue.slice(0, 12);
    }
    inputEl.value = inputValue;
  }

  private showNotificationModal(): void {
    const notificationConfig = getNotificationConfig(this.router.url, 'MEMBERSHIP');
    this.showNotification = notificationConfig.show;
    this.bodyText = notificationConfig.bodyTextKey;
  }

  openMembershipModal() {
    this.modalService.openModal(this.modalNamesEnum.Membership); 
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}